import * as React from 'react';
import { Box } from '@chakra-ui/react';
import { Row } from "@tanstack/react-table";
import { CellData, SelectOptions } from '../Table.types';
import { TableSelect } from '../components/TableSelect';

export function useColumnCell({ props, type, updateTableData }: any) {    
    const { table, cell: { getValue, row: { index: rowIndex }, column: { id: columnIndex }}} = props;    

    const initialValue = getValue(columnIndex);

    const [inputValue, setInputValue] = React.useState<string>("");
    const [selectValue, setSelectValue] = React.useState(initialValue && initialValue.value);

    function onInputChange(e: React.ChangeEvent<HTMLInputElement>) {
      setInputValue(e.target.value);
    }
  
    function onSelectChange(value: SelectOptions | SelectOptions[]) {
      if (!!Array.isArray(value)) {
        setSelectValue(value.map(item => item.value));
      } else {
        setSelectValue(value.value);
      }
    }

    function onBlur() {      
      table.options.meta?.updateData(rowIndex, columnIndex, inputValue)
    }
  
    function updateCellData({ rowIndex, columnId, value }: CellData) {      
      const newData = table?.options?.data?.map((row: Row<{}>, index: number) => {
        if (index === rowIndex) {
          return {
            ...table?.options?.data[rowIndex],
            [columnId]: { ...table?.options?.data[rowIndex][columnId], value }
          };
        }
        return row;
      });
      
      table.options.meta?.updateData(newData);
    }

    React.useEffect(() => {
      if (typeof initialValue === 'object') {
        setInputValue(initialValue?.value)
      } else {
        setInputValue(initialValue)
      }  
    }, [initialValue])
        
    switch (type.toLowerCase()) {
    case "url":
    case "text":
    case "email":
    case "phone":
    case "person":
    case "number":
      return (
       <span className="h--100">
          <Box
            as='input'
            width="100%"
            minWidth='6'
            value={inputValue}
            className="input h--100"
            padding={'1'}
            onChange={onInputChange}
            fontSize='sm'
            onBlur={onBlur}
            _focus={{ 
              bg: 'transparent', 
              zIndex: 1,
              borderColor: 'rgb(49, 130, 206)',
              boxShadow: 'rgb(49, 130, 206) 0px 0px 0px 1px' 
            }} 
          />
       </span>
      );
    case "date":
      return (
        <span className="h--100">
          <Box
            as='input'
            width="100%"
            minWidth='6'
            value={inputValue}
            className="input h--100"
            padding={'1'}
            onChange={onInputChange}
            fontSize='sm'
            onBlur={onBlur}
            type="date"
            _focus={{ 
              bg: 'transparent', 
              zIndex: 1,
              borderColor: 'rgb(49, 130, 206)',
              boxShadow: 'rgb(49, 130, 206) 0px 0px 0px 1px' 
            }} 
          />
       </span>
      );
    case "multi select":
      return (
        <TableSelect
          isMulti
          placeholder=""
          onChange={onSelectChange}
          options={initialValue?.options}
          value={
          Array.isArray(initialValue?.value)
            ? initialValue?.value.map((item: string) => ({
                value: item,
                label: item
            }))
            : [initialValue?.value].map((item: string) => ({
                value: item,
                label: item
            }))
          }
          defaultValue={
            Array.isArray(initialValue?.value)
              ? initialValue?.value.map((item: string) => ({
                value: item,
                label: item
              }))
              : [initialValue?.value].map((item: string) => ({
                  value: item,
                  label: item
              }))
          }
          onBlur={() => updateCellData({ rowIndex, columnId: columnIndex, value: selectValue })}
        />
      );
    case "select":
      return (
        <TableSelect
          placeholder=""
          onChange={onSelectChange}
          options={initialValue?.options}
          value={{
            value: initialValue?.value,
            label: initialValue?.value
          }}
          defaultValue={{
            value: initialValue?.value,
            label: initialValue?.value
          }}
          onBlur={onBlur}
        />
      );
    default:
      return null;
    }
  }
  